export * from '@primeuix/themes/material/password';
export { default } from '@primeuix/themes/material/password';
